<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'App',
  }
</script>

<style>
@import url("./assets/iconfont.css");
body{
  background-color: rgba(246, 246, 246, 1);
}
  .el-scrollbar__wrap{
    height: 300px !important;
  }
  .disabled .el-upload--picture-card {
          display: none !important;
      }
  /* 移动端字体 */
  .mobileFontSize {
    font-size: 12px !important;
  }

  .el-radio__label,
  .el-checkbox__label {
    font-size: 13px !important;
  }

  .searchHarm .el-input__suffix {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }

  /* .physicalExamination .el-table td,
  .searchHarm .el-table td { */
    /* padding: 0.25rem 0 !important; */
  /* } */

  .searchHarm .el-tabs--border-card>.el-tabs__content {
    padding: 0;
  }

  /* .physicFactor .el-table td,
  .el-table th { */
    /* padding: 1.2rem 0; */
  /* } */

  .tableBoxShadow {
    -moz-box-shadow: 0px 1px 7px #CFCFCF;
    -webkit-box-shadow: 0px 1px 7px #CFCFCF;
    box-shadow: 0px 1px 7px #CFCFCF;
    margin-top: 1.25rem;
  }

  .el-icon-loading {
    font-size: 2rem !important;
  }

  .el-input__inner {
    font-size: 13px !important;
  }

  /* .physicalExamination .el-select .el-input__inner {
    width: 10rem;
  } */

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 5.625rem;
    color: #99a9bf;
    font-size: 12px;
  }

  .subExpand label {
    width: 8.625rem !important;
  }

  .mobileTable {
    font-size: 12px;
  }

  .mobileMenu {
    font-size: 12px;
  }

  .mobilePage {
    height: 1.3125rem;
    line-height: 1.3125rem;
  }

  .mobilDialog {
    font-size: 12px;
  }

  /* .noiseLevelCompute .el-table .el-input__inner {
    border: none;
    outline: none;
  } */

  .noiseLevelCompute .el-table td,
  .el-table th {
    padding: 0;
  }
  .noiseLevelCompute .el-form-item__content{
    margin-left: 0 !important;
  }
  .noiseLevelCompute .el-form-item__error{
    top: 23%;
    left: 10rem;
  }
/* .searchdata .el-input__inner{
  height: 2.44rem !important;
  border: none;
} */

</style>



// WEBPACK FOOTER //
// src/App.vue